import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';  // Import Bootstrap Modal

// Function to decode HTML entities
const decodeHtml = (html) => {
    const text = document.createElement('textarea');
    text.innerHTML = html;
    return text.value;
  };
  
const VideosPage = ({ token }) => {
  const { channelId } = useParams();
  const [videos, setVideos] = useState([]);
  const [channelName, setChannelName] = useState('');
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchVideos = async () => {
      const response = await axios.get('https://www.googleapis.com/youtube/v3/search', {
        params: {
          part: 'snippet',
          channelId: channelId,
          maxResults: 50,
          order: 'date',  // Sort by most recent date
          safeSearch: 'moderate',  // Set SafeSearch to moderate
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVideos(response.data.items);
      if (response.data.items.length > 0) {
        setChannelName(response.data.items[0].snippet.channelTitle);  // Set channel name as title
      }
    };

    fetchVideos();
  }, [channelId, token]);

  const handleVideoClick = (videoId) => {
    setSelectedVideo(videoId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVideo(null);  // Clear the selected video when the modal is closed
  };

  return (
    <div className="container">
      <h2 className="my-4">{channelName}</h2>  {/* Display channel name */}
      <Link to="/channels" className="btn btn-secondary mb-4">Back to Channels</Link>
      <div className="row">
        {videos.map((video) => (
          <div className="col-md-3 col-sm-6 mb-4" key={video.id.videoId}>
            <div className="card" onClick={() => handleVideoClick(video.id.videoId)}>
              <img
                src={video.snippet.thumbnails.high.url}
                className="card-img-top"
                alt={decodeHtml(video.snippet.title)}
                style={{ width: '66%', height: 'auto', margin: '0 auto' }}  // Reduce size to 2/3
              />
              <div className="card-body">
                <h5 className="card-title text-center">{decodeHtml(video.snippet.title)}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for playing video */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Now Playing</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVideo && (
            <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo}?rel=0`}  // Add ?rel=0 to remove related videos
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube video player"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              ></iframe>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VideosPage;
